import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Button } from 'antd';
import {
  UserOutlined,
  TeamOutlined,
  FileOutlined,
  ApartmentOutlined,
  SolutionOutlined,
  DashboardOutlined,
  DollarOutlined,
  CreditCardOutlined,
  CarOutlined,
  IdcardOutlined,
  SettingOutlined,
  UsergroupAddOutlined,
  BankOutlined,
  ToolOutlined,
  CalendarOutlined,
  ProjectOutlined,
  FilePdfOutlined,
  UnorderedListOutlined,
  FileTextOutlined,
  UploadOutlined,

  LogoutOutlined
} from '@ant-design/icons';
import 'antd/dist/reset.css';
import './App.css';
import Login from './pages/Login';
import api, { imagepath } from './api';
import Departments from './pages/Departments';
import Employees from './pages/Employees';
import EmployeeAdd from './pages/EmployeeAdd';
import EmployeeEdit from './pages/EmployeeEdit';
import Subcontractors from './pages/Subcontractors';
import Clients from './pages/Clients';
import EmployeeAssignments from './pages/EmployeeAssignments';
import EmployeeTimesheets from './pages/EmployeeTimesheets';
import Vehicles from './pages/Vehicles';
import Licenses from './pages/Licenses';
import PettyCash from './pages/PettyCash';
import Settings from './pages/Settings';
import Skills from './pages/Skills';
import Payroll from './pages/Payroll';
import EmployeeLoans from './pages/EmployeeLoans';
import SubcontractorEmployeeAdd from './pages/SubcontractorEmployeeAdd';
import SubcontractorEmployeeEdit from './pages/SubcontractorEmployeeEdit';
import SubcontractorEmployeeView from './pages/SubcontractorEmployeeView';
import SubcontractorEmployeesPage from './pages/SubcontractorEmployeesPage';
import EmployeeView from './pages/EmployeeView';
// import Timesheet from './pages/Timesheet';
import { calc } from 'antd/es/theme/internal';
import SubcontractorInvoices from './pages/SubcontractorInvoices';
import Dashboard from './pages/Dashboard';
import CurrentAssignmentsPage from './pages/CurrentAssignmentsPage';
import logo from './logo.png';
import SubcontractorBilling from './pages/SubcontractorBilling';
import ClientBilling from './pages/ClientBilling';
import EmployeeTimesheetManager from './pages/EmployeeTimesheetManager';
import Notifications from './pages/Notifications';
import NotFound from './pages/NotFound';
import ExcelUploadManager from './pages/ExcelUploadManager';
import ExcelCombinedView from './pages/ExcelCombinedView';
import PayrollReport from './pages/PayrollReport';
import TaxInvoice from './pages/TaxInvoice';
import StatementOfAccount from './pages/StatementOfAccount';
import LpoList from './pages/Lpo/LpoList';
import LpoLedger from './pages/Lpo/LpoLedger';
import PaymentVouchers from './pages/PaymentVouchers';
import LeaveHistory from './pages/LeaveHistory';
import BlankTimesheets from './pages/BlankTimesheets';
import CheckPrinting from './pages/CheckPrinting';

const { Header, Sider, Content } = Layout;

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
}

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      api.get('/user', { headers: { Authorization: `Bearer ${token}` } }).then(res => {
        if (res.success) setUser(res.data);
      });
    }
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={setUser} />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <SidebarLayout user={user} />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

function SidebarLayout({ user }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [openKeys, setOpenKeys] = useState([]);
  const [logoUrl, setLogoUrl] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const rootSubmenuKeys = [
    'hr-management',
    'external-partners',
    'project-operations',
    'financial-operations',
    'asset-management',
  ];
  useEffect(() => {
    api.get('/settings').then(res => {
      if (res.data.success && res.data.data.logo) {
        setLogoUrl(`${imagepath}storage/${res.data.data.logo}`);
      }
    });
  }, []);
  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.includes(latestOpenKey)) {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    } else {
      setOpenKeys(keys);
    }
  };
  // Sidebar highlight logic
  const pathToKey = {
    '/dashboard': 'dashboard',
    '/departments': 'departments',
    '/employees': 'employees',
    '/notifications': 'notifications',
    '/subcontractors': 'subcontractors',
    '/clients': 'clients',
    '/employee-assignments': 'employee-assignments',
    '/current-assignments': 'current-assignments',
    '/employee-timesheets': 'employee-timesheets',
    '/employee-timesheet-manager': 'employee-timesheet-manager',
    '/vehicles': 'vehicles',
    '/licenses': 'licenses',
    '/petty-cash': 'petty-cash',
    '/payroll': 'payroll',
    '/employee-loans': 'employee-loans',
    '/skills': 'skills',
    '/subcontractor-invoices': 'subcontractor-invoices',
    '/excel-upload': 'excel-upload',
    '/file-upload-manager': 'file-upload-manager',
    '/report/generate': 'report-generate',
    '/report/payroll': 'report-payroll',
    '/report/payroll': 'report-payroll',
    '/report/processing': 'report-processing',
    '/report/tax-invoice': 'report-tax-invoice',
    '/report/soa': 'report-soa',
    '/lpos': 'lpos',
    '/payment-vouchers': 'payment-vouchers',
    '/leave-history': 'leave-history',
    '/blank-timesheets': 'blank-timesheets',
    '/check-printing': 'check-printing',
  };
  let activeKey = pathToKey[location.pathname];
  if (!activeKey) {
    if (location.pathname.startsWith('/employees')) activeKey = 'employees';
    else if (location.pathname.startsWith('/departments')) activeKey = 'departments';
    else if (location.pathname.startsWith('/subcontractors')) activeKey = 'subcontractors';
    else if (location.pathname.startsWith('/clients')) activeKey = 'clients';
    else if (location.pathname.startsWith('/employee-assignments')) activeKey = 'employee-assignments';
    else if (location.pathname.startsWith('/current-assignments')) activeKey = 'current-assignments';
    else if (location.pathname.startsWith('/employee-timesheets')) activeKey = 'employee-timesheets';
    else if (location.pathname.startsWith('/vehicles')) activeKey = 'vehicles';
    else if (location.pathname.startsWith('/licenses')) activeKey = 'licenses';
    else if (location.pathname.startsWith('/petty-cash')) activeKey = 'petty-cash';
    else if (location.pathname.startsWith('/payroll')) activeKey = 'payroll';
    else if (location.pathname.startsWith('/employee-loans')) activeKey = 'employee-loans';
    else if (location.pathname.startsWith('/skills')) activeKey = 'skills';
    else if (location.pathname.startsWith('/subcontractor-invoices')) activeKey = 'subcontractor-invoices';
    else if (location.pathname.startsWith('/file-upload-manager')) activeKey = 'file-upload-manager';
    else if (location.pathname.startsWith('/lpos')) activeKey = 'lpos';
    else if (location.pathname.startsWith('/payment-vouchers')) activeKey = 'payment-vouchers';
    else if (location.pathname.startsWith('/leave-history')) activeKey = 'leave-history';
    else if (location.pathname.startsWith('/check-printing')) activeKey = 'check-printing';
  }

  return (
    <Layout style={{ minHeight: '100vh', marginLeft: collapsed ? '80px' : '220px', transition: 'margin-left 0.2s' }}>
      <Sider
        theme="dark"
        breakpoint="lg"
        collapsedWidth="80"
        width={220}
        style={{
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 1,
          overflow: 'hidden'
        }}
        collapsed={collapsed}
        onCollapse={setCollapsed}
      >
        <div className="logo" style={{ color: 'white', textAlign: 'center', padding: 16 }}>
          <img src={logo} alt="Company Logo" style={{ maxWidth: 120, maxHeight: 48, marginBottom: 8, display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          paddingBottom: '64px', // Space for logout button
          overflow: 'hidden'
        }}>
          <div style={{
            overflowY: 'auto',
            flex: 1,
            paddingBottom: '20px' // Extra padding at the bottom
          }}>
            <Menu
              theme="dark"
              mode="inline"
              selectedKeys={[activeKey]}
              style={{ borderRight: 0, background: 'transparent' }}
              openKeys={openKeys}
              onOpenChange={onOpenChange}
              onClick={({ key }) => {
                if (key === 'departments') navigate('/departments');
                if (key === 'employees') navigate('/employees');
                if (key === 'notifications') navigate('/notifications');
                if (key === 'subcontractors') navigate('/subcontractors');
                if (key === 'clients') navigate('/clients');
                if (key === 'employee-assignments') navigate('/employee-assignments');
                if (key === 'current-assignments') navigate('/current-assignments');
                if (key === 'employee-timesheets') navigate('/employee-timesheets');
                if (key === 'employee-timesheet-manager') navigate('/employee-timesheet-manager');
                if (key === 'vehicles') navigate('/vehicles');
                if (key === 'licenses') navigate('/licenses');
                if (key === 'petty-cash') navigate('/petty-cash');
                if (key === 'payroll') navigate('/payroll');
                if (key === 'employee-loans') navigate('/employee-loans');
                if (key === 'skills') navigate('/skills');
                if (key === 'subcontractor-invoices') navigate('/subcontractor-invoices');
                if (key === 'dashboard') navigate('/dashboard');
                if (key === 'subcontractor-billing') navigate('/subcontractor-billing');
                if (key === 'client-billing') navigate('/client-billing');
                if (key === 'excel-upload') navigate('/excel-upload');
                if (key === 'file-upload-manager') navigate('/file-upload-manager');
                if (key === 'report-generate') navigate('/report/generate');
                if (key === 'report-payroll') navigate('/report/payroll');
                if (key === 'report-processing') navigate('/report/processing');
                if (key === 'report-tax-invoice') navigate('/report/tax-invoice');
                if (key === 'report-soa') navigate('/report/soa');
                if (key === 'processed-timesheets') navigate('/processed-timesheets');
                if (key === 'excel-viewer') navigate('/excel-viewer');
                if (key === 'generate') navigate('/report/generate');
                if (key === 'lpos') navigate('/lpos');
                if (key === 'payment-vouchers') navigate('/payment-vouchers');
                if (key === 'leave-history') navigate('/leave-history');
                if (key === 'blank-timesheets') navigate('/blank-timesheets');
                if (key === 'check-printing') navigate('/check-printing');
              }}
            >
              <Menu.Item key="dashboard" icon={<DashboardOutlined />}>Dashboard</Menu.Item>

              <Menu.SubMenu key="hr-management" icon={<TeamOutlined />} title="HR Management">
                <Menu.Item key="employees" icon={<UserOutlined />}>Employees</Menu.Item>
                <Menu.Item key="departments" icon={<ApartmentOutlined />}>Departments</Menu.Item>
                <Menu.Item key="leave-history" icon={<CalendarOutlined />}>Leave History</Menu.Item>
                <Menu.Item key="blank-timesheets" icon={<FileTextOutlined />}>Job Cards</Menu.Item>
                <Menu.Item key="check-printing" icon={<BankOutlined />}>Check Printing</Menu.Item>
              </Menu.SubMenu>

              <Menu.SubMenu key="external-partners" icon={<TeamOutlined />} title="External Partners">
                <Menu.Item key="clients" icon={<SolutionOutlined />}>Clients</Menu.Item>
                <Menu.Item key="subcontractors" icon={<TeamOutlined />}>Subcontractors</Menu.Item>
                <Menu.Item key="lpos" icon={<FileTextOutlined />}>LPOs</Menu.Item>
              </Menu.SubMenu>

              <Menu.SubMenu key="project-operations" icon={<ProjectOutlined />} title="Project Operations">
                <Menu.Item key="employee-assignments" icon={<SolutionOutlined />}>Employee Assignments</Menu.Item>
                {/* <Menu.Item key="current-assignments" icon={<CalendarOutlined />}>Current Assignments</Menu.Item> */}
                {/* <Menu.Item key="employee-timesheets" icon={<FileTextOutlined />}>Employee Timesheets</Menu.Item>
              <Menu.Item key="employee-timesheet-manager" icon={<FileOutlined />}>Timesheet Manager</Menu.Item>
              <Menu.Item key="processed-timesheets" icon={<FileTextOutlined />}>Processed Timesheets</Menu.Item>
              <Menu.Item key="report-generate" icon={<UploadOutlined />}>Generate Report</Menu.Item> */}
              </Menu.SubMenu>

              <Menu.SubMenu key="financial-operations" icon={<BankOutlined />} title="Financial Operations">
                <Menu.Item key="payroll" icon={<DollarOutlined />}>Payroll</Menu.Item>
                <Menu.Item key="employee-loans" icon={<CreditCardOutlined />}>Employee Loans</Menu.Item>
                <Menu.Item key="report-soa" icon={<FileTextOutlined />}>Statement of Account</Menu.Item>
                <Menu.Item key="payment-vouchers" icon={<FileTextOutlined />}>Payment Voucher</Menu.Item>
              </Menu.SubMenu>
              <Menu.Item key="petty-cash" icon={<DollarOutlined />}>Petty Cash</Menu.Item>

              <Menu.SubMenu key="asset-management" icon={<CarOutlined />} title="Asset Management">
                <Menu.Item key="vehicles" icon={<CarOutlined />}>Vehicles</Menu.Item>
                <Menu.Item key="licenses" icon={<IdcardOutlined />}>Licenses</Menu.Item>
              </Menu.SubMenu>

              <Menu.SubMenu key="reports" icon={<FilePdfOutlined />} title="Reports">
                {/* <Menu.Item key="generate" icon={<UploadOutlined />}>Generate Report</Menu.Item> */}
                <Menu.Item key="report-processing" icon={<FileTextOutlined />}>Summary</Menu.Item>
                <Menu.Item key="report-payroll" icon={<FileTextOutlined />}>Payroll</Menu.Item>
                <Menu.Item key="report-tax-invoice" icon={<FileTextOutlined />}>Tax Invoice</Menu.Item>
                <Menu.Item key="report-soa" icon={<FileTextOutlined />}>SOA</Menu.Item>
                {/* <Menu.Item key="subcontractor-invoices" icon={<FilePdfOutlined />}>Subcontractor Invoices</Menu.Item>
              <Menu.Item key="subcontractor-billing" icon={<FilePdfOutlined />}>Subcontractor Billing</Menu.Item>
              <Menu.Item key="client-billing" icon={<FilePdfOutlined />}>Client Billing</Menu.Item> */}
              </Menu.SubMenu>




              <Menu.Item key="settings" icon={<SettingOutlined />}>Settings</Menu.Item>
            </Menu>
          </div>

          {/* Fixed Logout Button at Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            borderTop: '1px solid #1f1f1f',
            background: '#001529',
            padding: '12px 0',
            textAlign: 'center'
          }}>
            <Button
              type="text"
              icon={<LogoutOutlined />}
              onClick={() => {
                localStorage.removeItem('token');
                window.location.href = '/login';
              }}
              style={{
                color: 'rgba(255, 255, 255, 0.65)',
                width: '100%',
                textAlign: 'left',
                paddingLeft: '24px',
                height: '40px',
                borderRadius: 0
              }}
            >
              Logout
            </Button>
          </div>
        </div>
      </Sider>

      <Layout style={{ marginLeft: 0, transition: 'margin-left 0.2s' }}>
        <Content style={{
          margin: '24px 16px 0',
          padding: '16px',
          minHeight: 'calc(100vh - 64px)'
        }}>
          <Routes>
            <Route path="/employees" element={<Employees />} />
            <Route path="/employees/add" element={<EmployeeAdd />} />
            <Route path="/employees/:id/edit" element={<EmployeeEdit />} />
            <Route path="/employees/:id/view" element={<EmployeeView />} />
            <Route path="/employees/:employeeId/leaves" element={<LeaveHistory />} />
            <Route path="/leave-history" element={<LeaveHistory />} />
            <Route path="/departments" element={<Departments />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/subcontractors" element={<Subcontractors />} />
            <Route path="/subcontractors/:subcontractorId/employees" element={<SubcontractorEmployeesPage />} />
            <Route path="/subcontractors/:subcontractorId/employees/add" element={<SubcontractorEmployeeAdd />} />
            <Route path="/subcontractors/:subcontractorId/employees/:employeeId/view" element={<SubcontractorEmployeeView />} />
            <Route path="/subcontractors/:subcontractorId/employees/:employeeId/edit" element={<SubcontractorEmployeeEdit />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/employee-assignments" element={<EmployeeAssignments />} />
            <Route path="/current-assignments" element={<CurrentAssignmentsPage />} />
            <Route path="/employee-timesheets" element={<EmployeeTimesheets />} />
            <Route path="/employee-timesheet-manager" element={<EmployeeTimesheetManager />} />
            <Route path="/vehicles" element={<Vehicles />} />
            <Route path="/licenses" element={<Licenses />} />
            <Route path="/petty-cash" element={<PettyCash />} />
            <Route path="/payment-vouchers" element={<PaymentVouchers />} />




            <Route path="/settings" element={<Settings />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/subcontractor-invoices" element={<SubcontractorInvoices />} />
            <Route path="/subcontractor-billing" element={<SubcontractorBilling />} />
            <Route path="/client-billing" element={<ClientBilling />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/payroll" element={<Payroll />} />
            <Route path="/employee-loans" element={<EmployeeLoans />} />
            <Route path="/report/generate" element={<ExcelUploadManager />} />
            <Route path="/report/processing" element={<ExcelCombinedView />} />
            <Route path="/report/payroll" element={<PayrollReport />} />
            <Route path="/report/tax-invoice" element={<TaxInvoice />} />
            <Route path="/report/soa" element={<StatementOfAccount />} />
            <Route path="/lpos" element={<LpoList />} />
            <Route path="/lpos/:id" element={<LpoLedger />} />
            <Route path="/blank-timesheets" element={<BlankTimesheets />} />
            <Route path="/check-printing" element={<CheckPrinting />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
